import { getDatabaseData } from "../../Functions/APIservice/useDatabase";
import { db } from "../../Environment/firebase";
import {
  collection,
  where,
  getDocs,
  query,
  DocumentData,
} from "firebase/firestore";
import { CaseCardType } from "../ViewCase/CaseCard";
import firebase from "firebase/compat/app";

type SearchQueryParams = {
  keyword: string;
  sex: string[];
  ages: string[];
  modality: string[];
  siteTags: string[];
  organTags: string[];
};

export default async function SearchQuery(
  params: SearchQueryParams
): Promise<CaseCardType[]> {
  const datalist: CaseCardType[] = [];
  const databaseRef = collection(db, "dwh");

  const querySnapshot = await getDocs(
    query(
      databaseRef,
      where("share", "==", "true"),
      where("destInstitutionCode", "==", "d151f295-42db-f3b4-a456-d1ad2ac17f09")
    )
  );
  if (querySnapshot.docs.length === 0) {
    console.log("データは0件です");
  } else {
    const docPromises = querySnapshot.docs.map(async (doc) => {
      const content: DocumentData = doc.data();
      let searchCounter = 0;

      if (params.keyword !== "") {
        const keyword = params.keyword.toLowerCase();

        if (
          (
            content.positiveFindings?.toLowerCase() ||
            content.findings.toLowerCase()
          ).includes(keyword) ||
          content.diagnosis.toLowerCase().includes(keyword) ||
          content.title?.toLowerCase().includes(keyword)
        ) {
          searchCounter += 0;
        } else {
          searchCounter += 1;
        }
      }

      if (params.sex.length > 0) {
        if (params.sex.includes(content.sex)) {
          searchCounter += 0;
        } else {
          searchCounter += 1;
        }
      }

      if (params.ages.length > 0) {
        if (params.ages.includes(content.ageSearch)) {
          searchCounter += 0;
        } else {
          searchCounter += 1;
        }
      }

      if (params.modality.length > 0) {
        if (params.modality.includes(content.modality)) {
          searchCounter += 0;
        } else {
          searchCounter += 1;
        }
      }

      if (params.siteTags.length > 0) {
        if (content.siteTags !== undefined) {
          const foundSite = params.siteTags.filter((element: string) =>
            content.siteTags.includes(element)
          );
          if (foundSite.length > 0) {
            searchCounter += 0;
          } else {
            searchCounter += 1;
          }
        } else {
          searchCounter += 1;
        }
      }

      if (params.organTags.length > 0) {
        if (content.organTags !== undefined) {
          const foundOrgan = params.organTags.filter((element: string) =>
            content.organTags.includes(element)
          );
          if (foundOrgan.length > 0) {
            searchCounter += 0;
          } else {
            searchCounter += 1;
          }
        } else {
          searchCounter += 1;
        }
      }

      const keyImagesRef = collection(doc.ref, "KeyImageData");
      const keyImagesSnapshot = await getDocs(
        query(keyImagesRef, where("share", "==", true))
      );
      const keyImagesFiltered = keyImagesSnapshot.docs.map(
        (imageDoc) => imageDoc.id
      );
      
      if (searchCounter === 0) {
        console.log("casenumber:", content.casenumber);
        return {
          id: content.id || "",
          title: content.title || "",
          age: content.ageSearch || "",
          sex: content.sex || "",
          patientId: content.patientId || "",
          site: content.site || "",
          modality: content.modality || "",
          date: content.uploadDate || "",
          organTags: content.organTags || [],
          keyImages: keyImagesFiltered,
          casenumber: content.casenumber || "",
          publishDate: content.publishDate || undefined,

        } as CaseCardType;
      }
    });

    const results = await Promise.all(docPromises);
    datalist.push(
      ...results.filter((item): item is CaseCardType => item !== undefined)
    );
  }
  return datalist;
}
